import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import RtlProvider from "../../../Components/RtlProvider";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import staticVariablesApi from "../../../api/staticVariablesApi";
import helper from "../../../helper";



const AirlinePanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  useEffect(() => {
    GetData();
  }, [refresh]);
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }

  const GetData = () => {
    setLoadingRows(true);
    staticVariablesApi.GetAirLineTypeDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        setData(arr)
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));


  };


  const columns = useMemo(
    () => [
      {
        accessorKey: 'value',
        header: 'نام',
        size: 100,
      },



    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: false,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>


      </Box>
    ),
  });


  return (
    <RtlProvider>
      <Typography component="h1" variant="h5" mb={2}>
        لیست هواپیمایی
      </Typography>
      <MaterialReactTable table={table} />
    </RtlProvider>
  );
}

export default AirlinePanel;
